import styles from './Account.module.css';

/**
 * Professional empty state used wherever real data doesn't exist yet (no saved
 * card, no invoices). `icon` is an emoji consistent with the app's icon style.
 */
export default function EmptyState({ icon = '-', title, description, action }) {
  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyIcon} aria-hidden="true">{icon}</div>
      <div className={styles.emptyTitle}>{title}</div>
      {description && <div className={styles.emptyDesc}>{description}</div>}
      {action && <div className={styles.emptyAction}>{action}</div>}
    </div>
  );
}
